import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=5469a15c&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"
import style0 from "./Preference.vue?vue&type=style&index=0&id=5469a15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469a15c",
  null
  
)

export default component.exports